import { ARTICLES_ES } from "./blogEs";
import { ARTICLES_EN } from "./blogEn";

export { ARTICLES_ES, ARTICLES_EN };

export const ARTICLE_PAIRS = ARTICLES_ES.map((a) => {
  const en = ARTICLES_EN.find((b) => b.id === a.id);
  return { id: a.id, es: { slug: a.slug }, en: { slug: en.slug } };
});

export function getArticle(lang, slug) {
  return (lang === "es" ? ARTICLES_ES : ARTICLES_EN).find((a) => a.slug === slug);
}
